<template>
  <div>
    <div style="background-color: white;padding-bottom: 10px">
<!--      <DxSelectBox
          :data-source="options"
          placeholder="请选择人群包"
          :show-clear-button="true"
          display-expr="text"
          value-expr="value"
          @valueChanged="onSelectChange"
          style="width: 300px;margin-left: 10px"
      />-->
      <DxButton
          v-for="(item, index) in btnGroup"
          :text="item.text"
          :type="item.type"
          styling-mode="contained"
          class="select-btn"
          :key=index
          :disabled="item.disabled"
          @click="handleBtnClick(item.text, index)"
      />
    </div>

    <div v-if="selectIndex === 0">
      <Taxpayer></Taxpayer>
    </div>
    <div v-else-if="selectIndex === 1">
      <TeXinQiYe></TeXinQiYe>
    </div>
    <div v-else-if="selectIndex === 2">
      <TaxA></TaxA>
    </div>
    <div v-else-if="selectIndex === 4">
      <SelfEmployeeCode></SelfEmployeeCode>
    </div>
    <div v-else-if="selectIndex === 8">
      <WinningCompany></WinningCompany>
    </div>
    <div v-else-if="selectIndex === -1">
      <h3></h3>
    </div>
    <div v-else>
      <h3>当前功能即将开放！敬请期待！</h3>
    </div>
  </div>
</template>

<script>
import Taxpayer from "@/views/personGroup/Taxpayer";
import SelfEmployeeCode from "@/views/personGroup/SelfEmployeeCode";
import TeXinQiYe from "@/views/personGroup/TeXinQiYe";
import WinningCompany from "@/views/personGroup/WinningCompany";
import TaxA from "@/views/personGroup/TaxA";

export default {
  components : {
    Taxpayer,
    SelfEmployeeCode,
    TeXinQiYe,
    WinningCompany,
    TaxA
  },
  data() {
    return {
      btnGroup: [
        {'text': '一般纳税人', 'type': 'success', 'disabled': false},
        {'text': '专精特新企业', 'type': 'success', 'disabled': false},
        {'text': '纳税A级', 'type': 'success', 'disabled': false},
        {'text': '海关进出口', 'type': 'success', 'disabled': true},
        {'text': '个体户银联码', 'type': 'success', 'disabled': false},
        {'text': '疑似网商贷需求企业', 'type': 'success', 'disabled': true},
        {'text': '高新科创企业', 'type': 'success', 'disabled': true},
        {'text': '出海各国家企业', 'type': 'success', 'disabled': true},
        {'text': '中标企业', 'type': 'success', 'disabled': false},
      ],
      selectIndex: -1,
      // options: [
      //   {'text': '一般纳税人', 'value': 0},
      //   {'text': '纳税A级', 'value': 1, disabled: true},
      //   {'text': '海关进出口', 'value': 2, disabled: true},
      //   {'text': '个体户银联码', 'value': 3},
      //   {'text': '疑似网商贷需求企业', 'value': 4, disabled: true},
      //   {'text': '高新科创企业', 'value': 5, disabled: true},
      //   {'text': '出海各国家企业', 'value': 6, disabled: true}
      // ],
    };
  },
  created() {

  },
  methods:{
    handleBtnClick(text, index){
      this.selectIndex = index
      const size = this.btnGroup.length
      for (let i = 0; i < size; i++) {
        if(index === i) {
          this.btnGroup[i].type = 'default'
        }else {
          this.btnGroup[i].type = 'success'
        }
      }
    },
    onSelectChange(e){
      this.selectIndex = e.value === null ? -1 : e.value
    }
  }
};
</script>
<style>
  .select-btn {
    margin-top: 10px;
    margin-left: 10px;
  }
</style>
